import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { FaFlask, FaAtom, FaDna, FaGlobe, FaCalculator, FaArrowRight, FaMicroscope, FaRocket, FaLightbulb, FaCog, FaLeaf, FaSearch, FaChevronLeft, FaChevronRight, FaEye, FaBalanceScale, FaTachometerAlt, FaBolt, FaPalette, FaCompass, FaMagnet, FaShieldAlt, FaThermometerHalf, FaHandPaper, FaRunning, FaCircle } from 'react-icons/fa';
import './Labs.css';

const Labs = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const [selectedSubject, setSelectedSubject] = useState('physics');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const labsPerPage = 10;

  const subjects = [
    {
      id: 'physics',
      name: 'الفيزياء',
      icon: <FaRocket />,
      color: '#e74c3c',
      labs: [
        {
          id: 'projectile-motion-lab',
          title: 'حركة المقذوفات',
          description: 'تجربة تفاعلية في حركة المقذوفات والمسار المكافئ',
          icon: <FaRocket />,
          image: '/public/physic.png'
        },
        {
          id: 'states-of-matter-basics-lab',
          title: 'أساسيات حالات المادة',
          description: 'تجربة في حالات المادة الأساسية (صلب، سائل، غاز)',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'states-of-matter-lab',
          title: 'حالات المادة',
          description: 'تجربة متقدمة في حالات المادة والتحولات',
          icon: <FaThermometerHalf />,
          image: '/public/physic.png'
        },
        {
          id: 'gravity-and-orbits-lab',
          title: 'الجاذبية والمدارات',
          description: 'تجربة في الجاذبية والمدارات الكوكبية',
          icon: <FaCompass />,
          image: '/public/physic.png'
        },
        {
          id: 'charges-and-fields-lab',
          title: 'الشحنات والمجالات',
          description: 'تجربة في الشحنات الكهربائية والمجالات',
          icon: <FaBolt />,
          image: '/public/physic.png'
        },
        {
          id: 'rutherford-scattering-lab',
          title: 'تشتت رذرفورد',
          description: 'تجربة في تشتت الجسيمات والنواة الذرية',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'bending-light-lab',
          title: 'انحناء الضوء',
          description: 'تجربة في انكسار وانعكاس الضوء',
          icon: <FaEye />,
          image: '/public/physic.png'
        },
        {
          id: 'hookes-law-lab',
          title: 'قانون هوك',
          description: 'تجربة في المرونة وقانون هوك',
          icon: <FaCog />,
          image: '/public/physic.png'
        },
        {
          id: 'energy-skate-park-lab',
          title: 'Energy Skate Park',
          description: 'تجربة في تحولات الطاقة الحركية والوضعية',
          icon: <FaRunning />,
          image: '/public/physic.png'
        },
        {
          id: 'faradays-law-lab',
          title: 'قانون فاراداي',
          description: 'تجربة في الحث الكهرومغناطيسي',
          icon: <FaMagnet />,
          image: '/public/physic.png'
        },
        {
          id: 'wave-on-a-string-lab',
          title: 'موجة على وتر',
          description: 'تجربة في الموجات الميكانيكية على الأوتار',
          icon: <FaCircle />,
          image: '/public/physic.png'
        },
        {
          id: 'color-vision-lab',
          title: 'رؤية الألوان',
          description: 'تجربة في الضوء والألوان والرؤية',
          icon: <FaPalette />,
          image: '/public/physic.png'
        },
        {
          id: 'balancing-act-lab',
          title: 'تمثيل الاتزان',
          description: 'تجربة في الاتزان والعزوم',
          icon: <FaBalanceScale />,
          image: '/public/physic.png'
        },
        {
          id: 'under-pressure-lab',
          title: 'الضغط',
          description: 'تجربة في الضغط وتأثيره على المادة',
          icon: <FaTachometerAlt />,
          image: '/public/physic.png'
        },
        {
          id: 'friction-lab',
          title: 'الاحتكاك',
          description: 'تجربة في قوى الاحتكاك وتأثيرها على الحركة',
          icon: <FaHandPaper />,
          image: '/public/physic.png'
        },
        {
          id: 'forces-and-motion-basics-lab',
          title: 'مبادئ القوة والحركة',
          description: 'تجربة أساسية في القوى والحركة',
          icon: <FaRunning />,
          image: '/public/physic.png'
        },
        {
          id: 'john-travoltage-lab',
          title: 'جون ترافولتاج',
          description: 'تجربة تفاعلية في الكهرباء الساكنة',
          icon: <FaBolt />,
          image: '/public/physic.png'
        },
        {
          id: 'gravity-force-lab',
          title: 'معمل قوة الجذب',
          description: 'تجربة في قوى الجذب بين الأجسام',
          icon: <FaCompass />,
          image: '/public/physic.png'
        },
        {
          id: 'balloons-and-static-electricity-lab',
          title: 'البالونات والكهرباء الساكنة',
          description: 'تجربة في الكهرباء الساكنة والبالونات',
          icon: <FaCircle />,
          image: '/public/physic.png'
        },
        {
          id: 'ohms-law-lab',
          title: 'قانون أوم',
          description: 'تجربة في العلاقة بين الجهد والتيار والمقاومة',
          icon: <FaBolt />,
          image: '/public/physic.png'
        },
        {
          id: 'resistance-in-a-wire-lab',
          title: 'مقاومة سلك',
          description: 'تجربة في مقاومة الموصلات الكهربائية',
          icon: <FaBolt />,
          image: '/public/physic.png'
        },
        {
          id: 'build-an-atom-lab',
          title: 'بناء ذرة',
          description: 'تجربة تفاعلية في بناء الذرات والعناصر',
          icon: <FaAtom />,
          image: '/public/physic.png'
        }
      ]
    },
    {
      id: 'chemistry',
      name: 'الكيمياء',
      icon: <FaFlask />,
      color: '#3498db',
      labs: [
        {
          id: 'build-a-nucleus-lab',
          title: 'بناء نواة',
          description: 'تجربة تفاعلية في بناء النواة الذرية',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'density-lab',
          title: 'الكثافة',
          description: 'تجربة في قياس الكثافة والكتلة والحجم',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'build-a-molecule-lab',
          title: 'بناء الجزيء',
          description: 'تجربة تفاعلية في بناء الجزيئات',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'diffusion-lab',
          title: 'الانتشار',
          description: 'تجربة في عملية الانتشار الجزيئي',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'gas-properties-lab',
          title: 'خصائص الغاز',
          description: 'تجربة في خصائص الغازات وقوانينها',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'blackbody-spectrum-lab',
          title: 'إشعاع الجسم الأسود',
          description: 'تجربة في إشعاع الجسم الأسود والطيف',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'energy-forms-and-changes-lab',
          title: 'أشكال الطاقة وتحولاتها',
          description: 'تجربة في تحولات الطاقة المختلفة',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'coulombs-law-lab',
          title: 'قانون كولوم',
          description: 'تجربة في قوى التجاذب والتنافر الكهربائي',
          icon: <FaBolt />,
          image: '/public/physic.png'
        },
        {
          id: 'molecule-polarity-lab',
          title: 'قطبية الجزيء',
          description: 'تجربة في قطبية الجزيئات والروابط',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'states-of-matter-basics-chem-lab',
          title: 'أساسيات حالات المادة',
          description: 'تجربة في حالات المادة الأساسية',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'states-of-matter-chem-lab',
          title: 'حالات المادة',
          description: 'تجربة متقدمة في حالات المادة والتحولات',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'rutherford-scattering-chem-lab',
          title: 'تشتت رذرفورد',
          description: 'تجربة في تشتت الجسيمات والنواة الذرية',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'isotopes-and-atomic-mass-lab',
          title: 'النظائر والكتلة الذرية',
          description: 'تجربة في النظائر والكتل الذرية',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'molecule-shapes-lab',
          title: 'أشكال الجزيئات',
          description: 'تجربة في أشكال الجزيئات والهندسة الجزيئية',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'molecule-shapes-basics-lab',
          title: 'أشكال الجزيء الأساسية',
          description: 'تجربة أساسية في أشكال الجزيئات',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'reactants-products-and-leftovers-lab',
          title: 'المتفاعلات والنواتج والمخلفات',
          description: 'تجربة في التفاعلات الكيميائية',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'ph-scale-basics-lab',
          title: 'مقياس الرقم الهيدروجيني',
          description: 'تجربة أساسية في مقياس pH',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'wave-on-a-string-chem-lab',
          title: 'موجة على وتر',
          description: 'تجربة في الموجات الميكانيكية',
          icon: <FaCircle />,
          image: '/public/physic.png'
        },
        {
          id: 'ph-scale-lab',
          title: 'مقياس pH',
          description: 'تجربة متقدمة في مقياس الرقم الهيدروجيني',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'balancing-chemical-equations-lab',
          title: 'وزن المعادلات الكيميائية',
          description: 'تجربة في موازنة المعادلات الكيميائية',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'acid-base-solutions-lab',
          title: 'محاليل الحمض والقاعدة',
          description: 'تجربة في الأحماض والقواعد',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'concentration-lab',
          title: 'التركيز',
          description: 'تجربة في تركيز المحاليل',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'balloons-and-static-electricity-chem-lab',
          title: 'البالونات والكهرباء الساكنة',
          description: 'تجربة في الكهرباء الساكنة',
          icon: <FaBolt />,
          image: '/public/physic.png'
        },
        {
          id: 'beers-law-lab',
          title: 'قانون بير',
          description: 'تجربة في قانون بير والامتصاص',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'molarity-lab',
          title: 'المولارية',
          description: 'تجربة في المولارية والتركيز المولي',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'build-an-atom-chem-lab',
          title: 'بناء ذرة',
          description: 'تجربة تفاعلية في بناء الذرات',
          icon: <FaAtom />,
          image: '/public/physic.png'
        }
      ]
    },
    {
      id: 'biology',
      name: 'الأحياء',
      icon: <FaDna />,
      color: '#27ae60',
      labs: [
        {
          id: 'density-bio-lab',
          title: 'الكثافة',
          description: 'تجربة في قياس الكثافة والكتلة والحجم',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'natural-selection-lab',
          title: 'الانتقاء الطبيعي',
          description: 'تجربة في آلية التطور والانتقاء الطبيعي',
          icon: <FaDna />,
          image: '/public/physic.png'
        },
        {
          id: 'gene-expression-essentials-lab',
          title: 'أساسيات التعبير الجيني',
          description: 'تجربة في التعبير الجيني والبروتينات',
          icon: <FaDna />,
          image: '/public/physic.png'
        },
        {
          id: 'molecule-polarity-bio-lab',
          title: 'قطبية الجزيء',
          description: 'تجربة في قطبية الجزيئات والروابط',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'neuron-lab',
          title: 'العصبون',
          description: 'تجربة في الخلايا العصبية والإشارات العصبية',
          icon: <FaMicroscope />,
          image: '/public/physic.png'
        },
        {
          id: 'color-vision-bio-lab',
          title: 'رؤية الألوان',
          description: 'تجربة في آلية رؤية الألوان في العين',
          icon: <FaEye />,
          image: '/public/physic.png'
        },
        {
          id: 'ph-scale-bio-lab',
          title: 'مقياس pH',
          description: 'تجربة في مقياس الرقم الهيدروجيني',
          icon: <FaFlask />,
          image: '/public/physic.png'
        }
      ]
    },
    {
      id: 'earth-science',
      name: 'علم الأرض',
      icon: <FaGlobe />,
      color: '#f39c12',
      labs: [
        {
          id: 'greenhouse-effect-lab',
          title: 'ظاهرة البيت الزجاجي',
          description: 'تجربة في تأثير البيت الزجاجي على المناخ',
          icon: <FaGlobe />,
          image: '/public/physic.png'
        },
        {
          id: 'density-earth-lab',
          title: 'الكثافة',
          description: 'تجربة في قياس الكثافة والكتلة والحجم',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'gravity-force-lab-basics-lab',
          title: 'مختبر قوة التجاذب',
          description: 'تجربة أساسية في قوى الجاذبية',
          icon: <FaCompass />,
          image: '/public/physic.png'
        },
        {
          id: 'waves-intro-lab',
          title: 'مقدمة الموجات',
          description: 'تجربة في أساسيات الموجات وخصائصها',
          icon: <FaCircle />,
          image: '/public/physic.png'
        },
        {
          id: 'diffusion-earth-lab',
          title: 'الانتشار',
          description: 'تجربة في عملية الانتشار الجزيئي',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'gas-properties-earth-lab',
          title: 'خصائص الغاز',
          description: 'تجربة في خصائص الغازات وقوانينها',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'blackbody-spectrum-earth-lab',
          title: 'إشعاع الجسم الأسود',
          description: 'تجربة في إشعاع الجسم الأسود والطيف',
          icon: <FaAtom />,
          image: '/public/physic.png'
        },
        {
          id: 'wave-interference-lab',
          title: 'تداخل الموجات',
          description: 'تجربة في تداخل الموجات والحيود',
          icon: <FaCircle />,
          image: '/public/physic.png'
        },
        {
          id: 'gravity-and-orbits-earth-lab',
          title: 'الجاذبية والمدارات',
          description: 'تجربة في الجاذبية والمدارات الكوكبية',
          icon: <FaCompass />,
          image: '/public/physic.png'
        },
        {
          id: 'wave-on-a-string-earth-lab',
          title: 'موجة على وتر',
          description: 'تجربة في الموجات الميكانيكية على الأوتار',
          icon: <FaCircle />,
          image: '/public/physic.png'
        },
        {
          id: 'ph-scale-earth-lab',
          title: 'مقياس pH',
          description: 'تجربة في مقياس الرقم الهيدروجيني',
          icon: <FaFlask />,
          image: '/public/physic.png'
        },
        {
          id: 'under-pressure-earth-lab',
          title: 'الضغط',
          description: 'تجربة في الضغط وتأثيره على المادة',
          icon: <FaTachometerAlt />,
          image: '/public/physic.png'
        },
        {
          id: 'gravity-force-lab-earth-lab',
          title: 'معمل قوة الجذب',
          description: 'تجربة في قوى الجذب بين الأجسام',
          icon: <FaCompass />,
          image: '/public/physic.png'
        },
        {
          id: 'balloons-and-static-electricity-earth-lab',
          title: 'البالونات والكهرباء الساكنة',
          description: 'تجربة في الكهرباء الساكنة والبالونات',
          icon: <FaBolt />,
          image: '/public/physic.png'
        }
      ]
    },
    {
      id: 'mathematics',
      name: 'الرياضيات',
      icon: <FaCalculator />,
      color: '#9b59b6',
      labs: [
        {
          id: 'vector-addition-lab',
          title: 'إضافة المتجهات',
          description: 'تجربة تفاعلية في جمع المتجهات وتمثيلها',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'masses-and-springs-lab',
          title: 'الكتل والزنبركات',
          description: 'تجربة في الحركة التوافقية البسيطة',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'pendulum-lab',
          title: 'معمل البندول',
          description: 'تجربة في حركة البندول البسيط',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'projectile-motion-math-lab',
          title: 'حركة المقذوفات',
          description: 'تجربة في حساب مسار المقذوفات',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'wave-on-a-string-math-lab',
          title: 'موجة على وتر',
          description: 'تجربة في حساب خصائص الموجات',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'balancing-act-math-lab',
          title: 'تمثيل الاتزان',
          description: 'تجربة في حساب العزوم والاتزان',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'ohms-law-math-lab',
          title: 'قانون أوم',
          description: 'تجربة في حساب المقاومة والجهد والتيار',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'resistance-in-a-wire-math-lab',
          title: 'مقاومة سلك',
          description: 'تجربة في حساب مقاومة الموصلات',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        },
        {
          id: 'number-theory-lab',
          title: 'معمل نظرية الأعداد',
          description: 'تجارب في نظرية الأعداد',
          icon: <FaCalculator />,
          image: '/public/physic.png'
        }
      ]
    }
  ];

  const currentSubject = subjects.find(subject => subject.id === selectedSubject);

  const handleLabClick = (labId) => {
    navigate(`/lab/${labId}`);
  };

  // Reset search and pagination when subject changes
  useEffect(() => {
    setSearchTerm('');
    setCurrentPage(1);
  }, [selectedSubject]);

  const filteredLabs = useMemo(() => {
    return currentSubject?.labs.filter(lab =>
      lab.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lab.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [currentSubject?.labs, searchTerm]);

  const totalPages = Math.ceil(filteredLabs.length / labsPerPage);
  const startIndex = (currentPage - 1) * labsPerPage;
  const endIndex = startIndex + labsPerPage;
  const currentLabs = filteredLabs.slice(startIndex, endIndex);

  return (
    <div className="labs-page">
      <div className="labs-container">
        {/* Sidebar */}
        <div className="labs-sidebar">
          <div className="labs-sidebar-header">
            <h2 className="labs-sidebar-title">معامل علمني</h2>
            <p className="labs-sidebar-subtitle">اختر المادة العلمية</p>
          </div>
          
          <div className="labs-subjects">
            {subjects.map((subject) => (
              <button
                key={subject.id}
                className={`labs-subject-btn ${selectedSubject === subject.id ? 'active' : ''}`}
                onClick={() => setSelectedSubject(subject.id)}
                style={{ '--subject-color': subject.color }}
              >
                <div className="labs-subject-icon">
                  {subject.icon}
                </div>
                <span className="labs-subject-name">{subject.name}</span>
                <FaArrowRight className="labs-subject-arrow" />
              </button>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="labs-main">
          <div className="labs-header">
            <div className="labs-header-content">
              <div className="labs-subject-info">
                <div className="labs-subject-icon-large" style={{ '--subject-color': currentSubject?.color }}>
                  {currentSubject?.icon}
                </div>
                <div className="labs-subject-details">
                  <h1 className="labs-subject-title">{currentSubject?.name}</h1>
                  <p className="labs-subject-description">
                    اكتشف {filteredLabs.length} معمل تفاعلي في {currentSubject?.name}
                  </p>
                </div>
              </div>
              
              <div className="labs-search-container">
                <div className="labs-search-box">
                  <FaSearch className="labs-search-icon" />
                  <input
                    type="text"
                    placeholder="ابحث في المعامل..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1); // Reset to first page when searching
                    }}
                    className="labs-search-input"
                  />
                  {searchTerm && (
                    <button
                      onClick={() => setSearchTerm('')}
                      className="labs-search-clear"
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="labs-grid">
            {currentLabs.length > 0 ? (
              currentLabs.map((lab) => (
              <div
                key={lab.id}
                className="labs-card"
                onClick={() => handleLabClick(lab.id)}
              >
                <div className="labs-card-header">
                  <div className="labs-card-icon" style={{ '--subject-color': currentSubject.color }}>
                    {lab.icon}
                  </div>
                  <div className="labs-card-badge">
                    <FaArrowRight />
                  </div>
                </div>
                
                <div className="labs-card-content">
                  <h3 className="labs-card-title">{lab.title}</h3>
                  <p className="labs-card-description">{lab.description}</p>
                </div>

                <div className="labs-card-footer">
                  <span className="labs-card-action text-white">ابدأ التجربة</span>
                </div>
              </div>
            ))
            ) : (
              <div className="labs-no-results">
                <div className="labs-no-results-icon">
                  <FaSearch />
                </div>
                <h3 className="labs-no-results-title">لا توجد نتائج</h3>
                <p className="labs-no-results-description">
                  لم يتم العثور على معامل تطابق البحث "{searchTerm}"
                </p>
                <button 
                  onClick={() => setSearchTerm('')}
                  className="labs-no-results-clear"
                >
                  مسح البحث
                </button>
              </div>
            )}
          </div>

          {totalPages > 1 && (
            <div className="labs-pagination">
              <button onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))} disabled={currentPage === 1}>
                <FaChevronRight />
                
              </button>
              <span>الصفحة {currentPage} من {totalPages}</span>
              <button onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))} disabled={currentPage === totalPages}>
                <FaChevronLeft />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Labs; 